// extracted by mini-css-extract-plugin
var _1 = "NotificationPopOver-module__active--H_YrK";
var _2 = "NotificationPopOver-module__animateUploadProgressBarWidth--oIZjH";
var _3 = "NotificationPopOver-module__animatedBackground--GGZxl";
var _4 = "NotificationPopOver-module__container--TuQBD";
var _5 = "NotificationPopOver-module__hidden--mA9bk";
var _6 = "NotificationPopOver-module__isNotificationsV2--guXoK";
var _7 = "NotificationPopOver-module__markAllButton--DqdlI";
var _8 = "NotificationPopOver-module__tabCount--OhvdM";
var _9 = "NotificationPopOver-module__tabHeader--eKxTk";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "hidden", _6 as "isNotificationsV2", _7 as "markAllButton", _8 as "tabCount", _9 as "tabHeader" }
